import { useCallback, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// Map legacy Bootstrap class to MUI color
const toMuiColor = (cls) => {
  if (cls?.includes('danger')) return 'error';
  if (cls?.includes('warning')) return 'warning';
  if (cls?.includes('success')) return 'success';
  return 'primary';
};

const ConfirmModal = ({
  open,
  title = 'Confirm',
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmColor = 'error',
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="inherit">{cancelText}</Button>
      <Button onClick={onConfirm} variant="contained" color={confirmColor}>{confirmText}</Button>
    </DialogActions>
  </Dialog>
);

export const useConfirmModal = () => {
  const [state, setState] = useState({ open: false, title: '', message: '', confirmText: '', cancelText: '', confirmColor: 'error', resolve: null });

  const confirm = useCallback(({ title = 'Confirm', message = 'Are you sure?', confirmText = 'Confirm', cancelText = 'Cancel', confirmClass = 'btn-danger', confirmColor } = {}) => {
    return new Promise((resolve) => {
      setState({ open: true, title, message, confirmText, cancelText, confirmColor: confirmColor || toMuiColor(confirmClass), resolve });
    });
  }, []);

  const handleConfirm = useCallback(() => {
    state.resolve?.(true);
    setState((s) => ({ ...s, open: false }));
  }, [state.resolve]);

  const handleCancel = useCallback(() => {
    state.resolve?.(false);
    setState((s) => ({ ...s, open: false }));
  }, [state.resolve]);

  const ConfirmModalContainer = (
    <ConfirmModal
      open={state.open}
      title={state.title}
      message={state.message}
      confirmText={state.confirmText}
      cancelText={state.cancelText}
      confirmColor={state.confirmColor}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    />
  );

  return { confirm, ConfirmModalContainer };
};

export default ConfirmModal;
